import { ReactNode, useRef, useState } from 'react';

import { Container, Tooltip, TooltipInner } from './SimpleTooltip.styled';

type Props = {
  text: ReactNode;
  offsetBottom?: number;
  positionAbove?: boolean;
  showArrow?: boolean;
  disabled?: boolean;
  children: ReactNode;
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
};

export function SimpleTooltip({
  text,
  positionAbove,
  showArrow,
  offsetBottom,
  disabled,
  children,
  xs,
  sm,
  md,
  lg,
  xl,
}: Props) {
  const [left, setLeft] = useState(0);
  const [top, setTop] = useState(0);
  const ref = useRef(null);

  const update = () => {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (ref && ref.current) {
      // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
      const rect = ref.current.getBoundingClientRect();
      if (positionAbove) {
        setTop(rect.top - rect.height + (offsetBottom || 0));
      } else {
        setTop(rect.top + rect.height + (offsetBottom || 0));
      }
      setLeft(rect.left + rect.width / 2);
    }
  };

  return (
    <Container ref={ref} onMouseOver={update} onFocus={update}>
      {children}
      {!disabled && (
        <Tooltip
          display={[xs, sm, md, lg, xl].map((n) => (n ? 'none' : 'block'))}
          $showArrow={showArrow}
          $positionAbove={positionAbove}
          left={left}
          top={top}
        >
          <TooltipInner>{text}</TooltipInner>
        </Tooltip>
      )}
    </Container>
  );
}
